import React from 'react';
import { Flex, JoyKitThemeProvider, TooltipV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { StatusLabel } from '@shared/components/StatusLabel';

interface ReservationCountBadgeProps
  extends Readonly<{
    reservationCount: number;
  }> {}

export const ReservationCountBadge: React.FC<ReservationCountBadgeProps> = ({ reservationCount }) => {
  const { tq } = useTranslation('hotelTile');

  return (
    <JoyKitThemeProvider>
      <TooltipV2
        overrides={{ Content: { props: { borderRadius: 6 } } }}
        content={
          <Flex
            flexDirection="column"
            maxWidth={pxToRem(256)}
          >
            <Flex
              typographyVariant={'label3'}
              color="white"
              fontWeight={700}
            >
              {tq.plural(reservationCount, {
                one: tq`One Guest Booked This Hotel`,
                other: tq`${reservationCount} Guests Booked This Hotel`,
              })}
            </Flex>
            <Flex
              typographyVariant={'label2'}
              color="white"
              fontWeight={400}
            >
              {tq.plural(
                reservationCount,
                {
                  one: tq`Joy has seen a booking at this hotel across our events recently. It's a popular spot. You should book soon.`,
                  other: tq`Joy has seen ${reservationCount} bookings at this hotel across our events recently. It's a popular spot. You should book soon.`,
                },
                { variables: { reservationsCount: reservationCount } },
              )}
            </Flex>
          </Flex>
        }
      >
        <StatusLabel gap={3}>
          {tq.plural(reservationCount, {
            one: tq`1 booking`,
            other: tq`${reservationCount} bookings`,
          })}
        </StatusLabel>
      </TooltipV2>
    </JoyKitThemeProvider>
  );
};
